import { ELocale } from '@lumahealthhq/ui-model-types';
import useUIUtilsContext from './useUIUtilsContext';
export default function useCurrentLocale() {
  const context = useUIUtilsContext();
  return (context == null ? void 0 : context.locale) || ELocale.EnglishUS;
}